import React, { useEffect } from "react";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { makeStyles } from "@material-ui/core/styles";
import { useScroll } from "../../../hooks";
import ProductCard from "./ProductCard";

const useStyles = makeStyles(theme => ({
  section: {
    padding: theme.spacing(4, 1)
  },
  title: {
    marginLeft: "2.5%",
    marginBottom: "0.25rem",
    fontWeight: 500,
    fontSize: "1.75rem"
  },
  products: {
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap"
  }
}));

const ProductSection = ({ index, title, products, executeScroll, onView, onSelectProduct }) => {
  const classes = useStyles();

  const [scroll, elementToScrollRef] = useScroll(70);

  useEffect(() => {
    if (executeScroll) {
      scroll();
    }
  }, [executeScroll, scroll]);

  useScrollPosition(
    ({ _, currPos }) => {
      if (currPos.y > 0 && currPos.y < window.innerHeight / 4) {
        onView(index);
      }
    },
    [],
    elementToScrollRef
  );

  return (
    <section ref={elementToScrollRef} className={classes.section}>
      <h2 className={classes.title}>{title}</h2>
      <div className={classes.products}>
        {products.map((p, i) => (
          <ProductCard key={`product-${i}`} product={p} onSelected={onSelectProduct} />
        ))}
      </div>
    </section>
  );
};

export default ProductSection;
